import { borderSizes, theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Paper } from 'shared/ui/Paper';
import { Typography } from 'shared/ui/Typography';

import styled from '@emotion/styled';

export const RootStyled = styled(Box)({
  width: '385px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  height: '100vh',
  position: 'sticky',
  flexShrink: 0,
  top: 0,
});

export const LogoStyled = styled(Paper)({
  display: 'flex',
  justifyContent: 'space-between',
  margin: theme.space[6],
  padding: `${theme.space[6]} ${theme.space[7]}`,
  backgroundColor: `${theme.colors.black}`,
  fontSize: theme.fontSizes[36],
  fontWeight: theme.fontWeights.extraBold,
  color: theme.colors.yellow800,
  position: 'relative',
  height: '93px',
  alignItems: 'center',
});

export const NavPanelStyled = styled(Paper)({
  height: '100%',
  margin: `0 ${theme.space[6]} ${theme.space[6]} ${theme.space[6]}`,
  backgroundColor: theme.colors.black,
  color: '#fff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'stretch',
  maxHeight: 'calc(100vh - 166px)',
});

export const LinksContainerStyled = styled(Box)`
  margin-top: ${({ theme }) => theme.space[4]};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const LinkList = styled(Box)`
  flex-grow: 1;
  display: flex;
`;

export const LinkStyled = styled(Typography)<{ $isActive?: boolean }>(({ $isActive }) => ({
  margin: `${theme.space[5]} ${theme.space[7]}`,
  fontSize: theme.fontSizes[36],
  fontWeight: theme.fontWeights.extraBold,
  color: $isActive ? theme.colors.yellow800 : 'inherit',

  '&:hover': {
    color: theme.colors.yellow800,
  },
}));

export const UserPanelStyled = styled(Paper)({
  backgroundColor: theme.colors.yellow800,
  color: theme.colors.black,
  padding: `${theme.space[5]} ${theme.space[7]}`,
  margin: `-${borderSizes.md}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
